import React from 'react';
import MaterialFormGroup from '@mui/material/FormGroup';
import type {FormGroupProps as MaterialFormGroupProps} from '@mui/material/FormGroup';

export type FormGroupProps = MaterialFormGroupProps;

export const FormGroup = React.forwardRef<any, FormGroupProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <MaterialFormGroup
                ref={ref}
                {...props}
            >
                {children}
            </MaterialFormGroup>
        );
    });

FormGroup.displayName = 'FormGroup';
